---
nb:
  dashboard:
    gwh_ytd: GWh i år
    m_currency_ytd: m{currency} i år
    mm_48h: 48T
    of_ytd_average: av 30 års snitt
    plants_in_operation: Kraftverk i drift
    total_volume: Totalt volum
    volume_for_asset_type: "{type} volum"
